import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submit"];

  connect() {
    this.originalData = this.formData();
    this.updateButtonState();
  }

  update(event) {
    this.updateButtonState();
  }

  updateButtonState() {
    const hasChanged = this.originalData !== this.formData();
    this.submitTarget.disabled = !hasChanged;
  }

  formData() {
    const formData = new FormData(this.element);
    return [...formData.entries()].map(([key, value]) => `${key}=${value}`).join("&");
  }
}
